module.exports = __webpack_public_path__ + "img/edit.d464783f.svg";